import React, {useState, useContext, useEffect} from "react";

import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from '@material-ui/core';

import { LockOutlined, Visibility, VisibilityOff, WhatsApp } from '@material-ui/icons';

import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";
import CryptoJS from "crypto-js";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  alignRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  ml5: {
    margin: theme.spacing(1),
    textDecoration: 'none',
    color: "black",
  }
}));

const Login = () => {
  const classes = useStyles();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [blockFields, setBlockFields] = useState(false);

  const { handleLogin, isBlocked } = useContext(AuthContext);

  useEffect(() => {
    const projectName = (window.env?.REACT_APP_NAME || process.env.REACT_APP_NAME) || "WhatsContábil";
    document.title = `${projectName} - Login`;

    if (isBlocked)
      setBlockFields(true);
  }, [isBlocked]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "." && e.shiftKey === false) {
        if (e.ctrlKey && e.key === ".") {
          setBlockFields(false);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const encryptData = (data) => {
    const secretKey = window.env?.REACT_APP_SECRET_KEY || process.env.REACT_APP_SECRET_KEY;
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  }

  const handlSubmit = (e) => {
    e.preventDefault();
    const oldPass = user.password;
    const oldEmail = user.email;
    user.password = encryptData(user.password);
    user.email = encryptData(user.email);
    handleLogin(user);
    user.password = oldPass;
    user.email = oldEmail;
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlined/>
        </Avatar>
        <Typography component="h1" variant="h5">
          {i18n.t("login.title")}
        </Typography>
        <form className={classes.form} noValidate onSubmit={handlSubmit}>
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={i18n.t("login.form.email")}
              name="email"
              value={user.email}
              onChange={handleChangeInput}
              autoComplete="email"
              autoFocus
          />
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={i18n.t("login.form.password")}
              id="password"
              value={user.password}
              onChange={handleChangeInput}
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((e) => !e)}
                      >
                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                      </IconButton>
                    </InputAdornment>
                )
              }}
          />
          <Button
              type={!blockFields ? "submit" : "button"}
              fullWidth
              disabled={blockFields}
              variant="contained"
              color={blockFields ? "secondary" : "primary"}
              className={classes.submit}
          >
            {!blockFields ? i18n.t("login.buttons.submit") : "SISTEMA BLOQUEADO"}
          </Button>
        </form>
        { blockFields && (
          <>
            <Typography component="body" variant="subtitle1">Para mais inforções, entrar em contato</Typography>
            <div className={classes.alignRow}>
              <WhatsApp/>
              <a target="_blank" rel="noopener noreferrer" href={"https://api.whatsapp.com/send/?phone=5514997613595&text=Meu+acesso+do+WhatsCont%C3%A1bil+est%C3%A1+bloqueado%2C+como+proceder%3F&type=phone_number&app_absent=0"} className={classes.ml5}><b>Suporte</b> +55 14 99761-3595</a>
            </div>
            <div className={classes.alignRow}>
              <WhatsApp/>
              <a target="_blank" rel="noopener noreferrer" href={"https://api.whatsapp.com/send/?phone=5514997613595&text=Meu+acesso+do+WhatsCont%C3%A1bil+est%C3%A1+bloqueado%2C+como+proceder%3F&type=phone_number&app_absent=0"} className={classes.ml5}><b>Financeiro</b> +55 14 99656-7101</a>
            </div>
          </>
        )}

        {/*{new Date().getDate() === 17 && new Date().getMonth() + 1 === 3 && new Date().getFullYear() === 2026 && (
            <div
                style={{
                  backgroundColor: "#fff4e5",
                  border: "1px solid #f0c36d",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "16px 0",
                  color: "#663c00",
                  lineHeight: "1.5",
                }}
            >
              <h3 style={{margin: "0 0 12px 0"}}>Comunicado Importante</h3>

              <p style={{margin: "0 0 10px 0"}}>
                Identificamos um problema técnico em nosso banco de dados que exigiu
                uma intervenção imediata para garantir a integridade das informações e
                a continuidade dos serviços.
              </p>

              <p style={{margin: "0 0 10px 0"}}>
                Para normalização do sistema, foi necessário restaurar o último backup
                disponível, realizado às <strong>07:30</strong> de hoje.
              </p>

              <p style={{margin: "0 0 10px 0"}}>
                Com isso, eventuais registros ou alterações realizadas após esse horário
                podem não ter sido mantidos.
              </p>

              <p style={{margin: 0}}>
                Nossa equipe já está atuando para validar os dados e minimizar qualquer
                impacto. Caso identifique alguma inconsistência, pedimos que entre em
                contato com nosso suporte.
              </p>
            </div>
        )}*/}
      </div>
    </Container>
  );
};

export default Login;
